import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'environment/environment';
import { Customerverification, CVParams, clsPartnerlist, GlobalSearch, customercvaccountcheck, spidverfication } from "./CustomerVerification.model";
import { Observable, catchError, throwError } from "rxjs";
import { AuthService } from "app/core/auth/auth.service";
import { User } from "app/core/user/user.types";




@Injectable({
  providedIn: 'root'
})
export class CustomerVerificationservice {
  user: User;
  private apiUrl: string;
  cls : customercvaccountcheck = new customercvaccountcheck() ; 
  cls_Spid : spidverfication = new spidverfication() ; 

  constructor(private _httpClient: HttpClient, private _auth: AuthService) {
    this.apiUrl = environment.baseUrl;
    this.user = JSON.parse(_auth.accessUser);
  }

  CustomerVerification(search: string, rowsPerPage: number, page: number, Customerverification: Customerverification): Observable<any> {



    this.user = JSON.parse(this._auth.accessUser);
    Customerverification.user_id = this.user.id;
    if (Customerverification.customerID == null || Customerverification.customerID == "") {
      Customerverification.customerID = 0;
    }

    if (
      (Customerverification.coreSPID == null || Customerverification.coreSPID == "") &&
      (Customerverification.customerID == null || Customerverification.customerID == 0) &&
      (Customerverification.emailID == null || Customerverification.emailID == "") &&
      (Customerverification.telephoneNumber == null || Customerverification.telephoneNumber == "") &&
      (Customerverification.Postcode == null || Customerverification.Postcode == "")
    ) {
      alert('Please Enter any one');
      return;
    }
  


   
    
    var pageno = Customerverification.PageNo;
    var pagesize = Customerverification.PageSize;


    let params = new HttpParams();
    params = params.append('PageNo', page);
    params = params.append('PageSize', rowsPerPage);
    if (search && search !== undefined) {
      params = params.append('Search', search);
    }
    params = params.append('CustomerID', Customerverification.customerID);
    params = params.append('CoreSPID', Customerverification.coreSPID);
    params = params.append('EmailID', Customerverification.emailID);
    params = params.append('user_id', Customerverification.user_id);
    params = params.append('TelephoneNumber', Customerverification.telephoneNumber);
    params = params.append('Postcode', Customerverification.Postcode);


    return this._httpClient.get<clsPartnerlist[]>(this.apiUrl + 'PartnerDashboard/CustomerVerification', {
      observe: 'body',
      params,
    });


  }

  globalSearch(search: string, rowsPerPage: number, page: number, GlobalSearch: GlobalSearch): Observable<any> {
    this.user = JSON.parse(this._auth.accessUser);
    
    GlobalSearch.user_id = this.user.id;
    GlobalSearch.search = search;
    GlobalSearch.pageNo = page;
    GlobalSearch.pageSize = rowsPerPage;


    return this._httpClient.post<clsPartnerlist>(this.apiUrl + 'PartnerDashboard/Global_Search', GlobalSearch).pipe(catchError(this.handleError));;

  }
  cvAccountno(customerID: number , userid : number): Observable<any> {
    this.user = JSON.parse(this._auth.accessUser);

    this.cls.Id = Number(customerID);
    this.cls.user_id = Number(userid);


    return this._httpClient.post<any>(this.apiUrl + 'Mydetail/checkaccountid', this.cls).pipe(catchError(this.handleError));;

  }

 VerifySpid(SPID: string , userid : number,type: string): Observable<any> {
  
    this.user = JSON.parse(this._auth.accessUser);

    this.cls_Spid.spid = SPID;
    this.cls_Spid.user_id = Number(userid);
    this.cls_Spid.type = type;

    return this._httpClient.post<any>(this.apiUrl +'Mydetail/VerifySpid', this.cls_Spid).pipe(catchError(this.handleError));;

  }


  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

}

